import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import AccessibilityOutlinedIcon from '@mui/icons-material/AccessibilityOutlined';
import RestaurantMenuOutlinedIcon from '@mui/icons-material/RestaurantMenuOutlined';
import VaccinesOutlinedIcon from '@mui/icons-material/VaccinesOutlined';
import DeviceThermostatOutlinedIcon from '@mui/icons-material/DeviceThermostatOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import { MODULE_KEYS } from '../../appointment/modules/appointmentModules';
import { getScale } from '../../appointment/modules/scales';

// Os mesmos ícones das maquetes do editor (popup/CreateEditAppointmentType/ModulePreview.js)
const ICONS = {
    [MODULE_KEYS.NOTES]: StickyNote2OutlinedIcon,
    [MODULE_KEYS.COMPLAINTS]: MedicalInformationOutlinedIcon,
    [MODULE_KEYS.EVOLUTION]: AssignmentOutlinedIcon,
    [MODULE_KEYS.ANAMNESIS]: HistoryEduOutlinedIcon,
    [MODULE_KEYS.CRANIAL_ASYMMETRY]: MonitorHeartOutlinedIcon,
    [MODULE_KEYS.GROWTH_CURVE]: ShowChartOutlinedIcon,
    [MODULE_KEYS.MOTOR_MILESTONES]: ChildCareOutlinedIcon,
    [MODULE_KEYS.AIMS]: AccessibilityNewOutlinedIcon,
    [MODULE_KEYS.DIAGNOSES]: LocalHospitalOutlinedIcon,
    [MODULE_KEYS.DOCUMENTS]: DescriptionOutlinedIcon,
    [MODULE_KEYS.ATTACHMENTS]: FolderOutlinedIcon,
    [MODULE_KEYS.BODY_MEASUREMENTS]: StraightenOutlinedIcon,
    [MODULE_KEYS.EVOLUTION_PHOTOS]: PhotoLibraryOutlinedIcon,
    [MODULE_KEYS.BODY_MAP]: AccessibilityOutlinedIcon,
    [MODULE_KEYS.MEAL_PLAN]: RestaurantMenuOutlinedIcon,
    [MODULE_KEYS.APPLICATION_MAP]: VaccinesOutlinedIcon,
    [MODULE_KEYS.THERMOGRAPHY]: DeviceThermostatOutlinedIcon,
};

/** Ícone do módulo; escalas usam o ícone do catálogo e o resto cai num ícone genérico. */
export function getModuleIcon(key) {
    if (ICONS[key]) return ICONS[key];
    const scale = getScale(key);
    if (scale) return scale.icon || TuneOutlinedIcon;
    return WidgetsOutlinedIcon;
}
